import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SysAdminService } from "../services/sysadmin.service";
import { RoleAdminAddRoleComponent } from "./role-admin-add-role/role-admin-add-role.component";
import { RoleAdminCopyRoleComponent } from "./role-admin-copy-role/role-admin-copy-role.component";
import { RoleAdminEditRoleComponent } from "./role-admin-edit-role/role-admin-edit-role.component";

@Component({
	selector: "app-manage-roles",
	templateUrl: "./manage-roles.component.html",
	styleUrls: ["./manage-roles.component.css"],
})
export class ManageRolesComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private schoolService: SchoolService,
		private sysAdminService: SysAdminService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////

	subscription: any;

	user: any;

	//Selector
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";
	SchoolID: any;
	lstSchool: any = [];

	//Table
	SelectedRole: any;
	lstRoles: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	//Filter Lists
	lstDefinedByDesc: any = [];
	lstUserLevelDesc: any = [];
	lstActiveDesc: any = [];
	lstSchoolName: any = [];

	errorMessage: any = "";
	ToggleText: any = "Deactivate Role";

	loading: any = false;

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				//Load roles
				this.loadRoles();
			},
			(error) => {}
		);
	}

	loadRoles() {
		this.loading = true;

		var result = this.sysAdminService.RoleSelectEditList(this.SchoolID, 2);
		result.subscribe(
			(response) => {
				this.lstRoles = response;

				this.lstDefinedByDesc = Array.from(new Set(this.lstRoles.map((item: any) => item.DefinedByDesc))).sort();
				this.lstUserLevelDesc = Array.from(new Set(this.lstRoles.map((item: any) => item.UserLevelDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstRoles.map((item: any) => item.ActiveDesc))).sort();
				this.lstSchoolName = Array.from(new Set(this.lstRoles.map((item: any) => item.SchoolName))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////
	onRefresh() {
		this.loadRoles();
	}

	onAddRole() {
		this.errorMessage = "";

		var ref = this.dialogService.open(RoleAdminAddRoleComponent, {
			header: "Add Role",
			width: "fit-content",
			data: {
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadRoles();
			}
		});
	}

	onRowDblClick(val) {
		this.SelectedRole = val;

		this.ToggleText = "Deactivate Role";
		if (this.SelectedRole.Active == false) {
			this.ToggleText = "Activate Role";
		}

		this.onEditRole();
	}
	onEditRole() {
		this.errorMessage = "";

		if (this.SelectedRole == undefined || this.SelectedRole == null) {
			this.errorMessage = "Select a role to edit";
			return;
		}

		var ref = this.dialogService.open(RoleAdminEditRoleComponent, {
			header: "Edit Role",
			width: "fit-content",
			data: {
				RoleID: this.SelectedRole.RoleID,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadRoles();
			}
		});
	}

	onCopyRole() {
		this.errorMessage = "";

		if (this.SelectedRole == undefined || this.SelectedRole == null) {
			this.errorMessage = "Select a role to copy";
			return;
		}

		var ref = this.dialogService.open(RoleAdminCopyRoleComponent, {
			header: "Copy Role",
			width: "fit-content",
			data: {
				RoleID: this.SelectedRole.RoleID,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadRoles();
			}
		});
	}

	onToggleRole() {
		if (this.SelectedRole == undefined || this.SelectedRole == null) {
			this.errorMessage = "Select a role to toggle";
			return;
		}

		var active = this.SelectedRole.Active == true ? 0 : 1;

		if (this.SelectedRole.DefinedByID <= 2) {
			this.errorMessage = "Cannot activate or deactivate system-defined roles";
			return;
		}

		var result = this.sysAdminService.RoleToggle(this.SelectedRole.RoleID, active);
		result.subscribe(
			(response) => {
				//Load roles
				this.loadRoles();
				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}

	onDeleteRole() {
		if (this.SelectedRole == undefined || this.SelectedRole == null) {
			this.errorMessage = "Select a role to delete";
			return;
		}

		var DeleteMsg = "Are you sure you want to delete the role: " + this.SelectedRole.RoleName + "?";
		this.confirmationService.confirm({
			key: "MainPage",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: DeleteMsg,
			header: "Security Role Maintenance",
			icon: "fa",
			accept: () => {
				this.ConfirmDelete();
			},
		});
	}

	ConfirmDelete() {
		var result = this.sysAdminService.RoleDelete(this.SelectedRole.RoleID);
		result.subscribe(
			(response) => {
				//Load roles
				this.loadRoles();
				this.onRowUnselect(null);
			},
			(error) => {}
		);
	}

	onExportUsers() {
		if (this.SelectedRole == undefined || this.SelectedRole == null) {
			this.errorMessage = "Select a role to export a list of users that have that role";
			return;
		}

		var result = this.sysAdminService.RoleExportUser(this.SelectedRole.RoleID);
		result.subscribe(
			(response: any) => {
				console.log(response);

				var a = document.createElement("a"); //Create <a>
				a.href = "data:text/csv;base64," + response.FileB64;
				a.download = response.FileName + ".csv";
				a.click(); //Downloaded file
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////////

	//////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadRoles();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedRole = val.data;

		this.ToggleText = "Deactivate Role";
		if (this.SelectedRole.Active == false) {
			this.ToggleText = "Activate Role";
		}
	}

	onRowUnselect(val) {
		this.SelectedRole = null;

		this.ToggleText = "Deactivate Role";
	}
	//////////////////////////////////////////////
}
